function applyCustomFontSpacing() {
  const targetFontFamily = 'Paris-Slant';
  const elements = document.body.getElementsByTagName('*');

  if (elements.length === 0) {
    return;
  }

  for (let el of elements) {
    try {
      const style = window.getComputedStyle(el);
      const fontFamily = style.fontFamily;

      if (fontFamily.toLowerCase().includes(targetFontFamily.toLowerCase())) {
        const fontSize = parseFloat(style.fontSize);

        if (fontSize >= 20) {
          el.style.letterSpacing = '-0.5px';
          el.style.wordSpacing = '-4px';
        }
        else if (fontSize >= 15) {
          el.style.letterSpacing = '-0.15px';
          el.style.wordSpacing = '-4px';
        }
        else if (fontSize <= 14) {
          el.style.letterSpacing = '0px';
          el.style.wordSpacing = '-2px';
        }
        else {
          el.style.letterSpacing = '0px';
          el.style.wordSpacing = '0px';
        }
      }
    } catch (e) {}
  }
}

window.addEventListener('load', function() {
  applyCustomFontSpacing();
  setTimeout(applyCustomFontSpacing, 500);
});

document.addEventListener('DOMContentLoaded', function() {
  const allRatingContainers = document.querySelectorAll('.product__rating');
  allRatingContainers.forEach(container => {
    const countElement = container.querySelector('.product__rating__count');
    if (countElement) {
      const starsToAdd = 4; 

      for (let i = 0; i < starsToAdd; i++) {
        const newStar = document.createElement('span');
        newStar.className = 'product__rating__star';
        container.insertBefore(newStar, countElement);
      }
    }
  });
});


// document.addEventListener('DOMContentLoaded', function() {
//   // Select the main container for the section
//   const customTabSection = document.querySelector('.custom-tab-section');

//   if (customTabSection) {
//     // Find the add to cart button within this specific section
//     const addToCartButton = customTabSection.querySelector('.stain-button-canvas.group\\/quick-action-button');

//     // Find the target info div within this specific section
//     const productInfoDiv = customTabSection.querySelector('.product__grid__info.text-center');

//     // Check if both elements were found before trying to move them
//     if (addToCartButton && productInfoDiv) {
//       // Append the button to the end of the product info div
//       productInfoDiv.appendChild(addToCartButton);
//     }
//   }
// });